module.exports = __webpack_public_path__ + "static/docker-4e7301538895cdc19b0eb5f2a3b60730.png";